import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.model';

export const CONSTS = {
  LABEL: $localize`Enable EDI Delay`,
  DROPDOWN_TEXT: $localize`Minute Delay Iteration`,
};

export const DELAY_OPTIONS: IOption[] = [
  {
    label: '15',
    value: 15,
  },
  {
    label: '30',
    value: 30,
  },
  {
    label: '45',
    value: 45,
  },
  {
    label: '60',
    value: 60,
  },
];
